// Modified from:
// https://github.com/thomasboyt/transit-immutable-js/blob/records-support/index.js

// With changes:
//  * Records can't simply be serialized with 'toJS', since
//    records may contain other composite types.
//  * Serialize with array for efficiency.
//  * Build records into an object first instead of using 'asMutable',
//    due to weird bug with 'id' containing records.

import transit from 'transit-js';
import Immutable from 'immutable';

function createReader(recordMap, defaultRecord) {
  return transit.reader('json', {
    mapBuilder: {
      init: function () {
        return {};
      },

      add: function (m, k, v) {
        m[k] = v;
        return m;
      },

      finalize: function (m) {
        return m;
      },
    },
    handlers: {
      iM: function (v) {
        var o = {};
        for (var i = 0; i < v.length; i += 2) {
          o[v[i]] = v[i + 1];
        }

        return new Immutable.Map(o);
      },

      iL: function (v) {
        return Immutable.List(v);
      },

      iR: function (v) {
        var Record = recordMap[v[0]];
        if (!Record) {
          var msg = ('Tried to deserialize Record type named `' + v[0] + '`, ' +
                     'but no type with that name was passed to withRecords()');
          if (defaultRecord) {
            if (console) console.error(msg);
            return new recordMap[defaultRecord]();
          } else {
            throw new Error(msg);
          }
        }

        var o = {};
        for (var i = 1; i < v.length; i += 2) {
          o[v[i]] = v[i + 1];
        }

        return new Record(o);
      },
    },
  });

}

var reader = createReader([]);
var writer = createWriter(false, []);

export function toJSON(data) {
  return writer.write(data);
}

export function fromJSON(data) {
  return reader.read(data);
}

export function withFilter(predicate) {
  var filteredWriter = createWriter(predicate, []);
  return {
    toJSON: function (data) {
      return filteredWriter.write(data);
    },

    fromJSON: fromJSON,
  };
}

export function withRecords(records, defaultRecord, predicate) {
  var recordMap = {};

  records.forEach(function (RecordType) {
    var rec = new RecordType({});

    if (!rec._name) {
      throw new Error('Cannot (de)serialize Record() without a name field');
    }

    recordMap[rec._name] = RecordType;
  });

  var recordWriter = createWriter(predicate, recordMap);
  var recordReader = createReader(recordMap, defaultRecord);

  return {
    toJSON: function (data) {
      return recordWriter.write(data);
    },

    fromJSON: function (data) {
      return recordReader.read(data);
    },
  };
}

function createWriter(predicate, recordMap) {
  var handlers = transit.map([
    Immutable.Map, transit.makeWriteHandler({
      tag: function () {
        return 'iM';
      },

      rep: function (m) {
        var i = 0, a = new Array(2 * m.size);
        if (predicate) {
          m = m.filter(predicate);
        }

        m.forEach(function (v, k) {
          a[i++] = k;
          a[i++] = v;
        });

        return a;
      },
    }),
    Immutable.List, transit.makeWriteHandler({
      tag: function () {
        return 'iL';
      },

      rep: function (v) {
        if (predicate) {
          v = v.filter(predicate);
        }

        return v.toArray();
      },
    }),
    Function, transit.makeWriteHandler({
      tag: function () {
        return '_';
      },

      rep: function () {
        return null;
      },
    }),
  ]);

  Object.keys(recordMap).forEach(function (name) {
    handlers.set(recordMap[name], makeRecordHandler(name, recordMap[name], predicate));
  });

  return transit.writer('json', {
    handlers: handlers,
  });
}

function makeRecordHandler(name, Record, predicate) {
  var rec = new Record();
  return transit.makeWriteHandler({
    tag: function () {
      return 'iR';
    },

    rep: function (m) {
      var i = 0, a = new Array(); //2 * m.size + 1);
      a.push(name); //a[i++] = name;
      if (predicate) {
        m = m.filter(predicate);
      }

      m.forEach(function (v, k) {
        let d = rec.get(k);
        if (d !== v && !Immutable.is(d, v)) {
          a.push(k); //a[i++] = k;
          a.push(v); //a[i++] = v;
        }
      });

      return a;
    },
  });
}



// WEBPACK FOOTER //
// ./src/store/transitImmutable.js